"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Erc1363EventType = void 0;
var Erc1363EventType;
(function (Erc1363EventType) {
    Erc1363EventType["TransferReceived"] = "TransferReceived";
})(Erc1363EventType || (exports.Erc1363EventType = Erc1363EventType = {}));
//# sourceMappingURL=erc1363.js.map